export const FILE_ORIGINAL = 'original'
export const FILE_MEDIUM = 'medium'
export const FILE_THUMBNAIL = 'thumbnail'
export const FILE_SIZES = [FILE_THUMBNAIL, FILE_MEDIUM, FILE_ORIGINAL]
export const DRAWING_IMAGE_MIN_WIDTH = 1000
export const DRAWING_IMAGE_MIN_HEIGHT = 700

export default {
  FILE_ORIGINAL,
  FILE_MEDIUM,
  FILE_THUMBNAIL,
  FILE_SIZES,
  DRAWING_IMAGE_MIN_WIDTH,
  DRAWING_IMAGE_MIN_HEIGHT
} as const
